import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { NodeService } from '../../shared/services/nodeservice.service';
import { Applications } from '../../shared/services/applications';
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";

interface applicationStatus {
    statusName: string;
    value: string;
}

@Component({
    selector: 'app-applications-callback',
    templateUrl: './applications-callback.component.html'
})
export class ApplicationsCallbackComponent implements OnInit {

    loading: boolean;
    files1: Applications[];
    selectedNode1: Applications;

    cols: any[];

    filterForm: FormGroup;
    applicationStatus: applicationStatus[];
    selectedStatus: applicationStatus[];
    status: any;

    constructor(private title: Title, private router: Router, private nodeService: NodeService, private fb: FormBuilder) {
        this.title.setTitle('Applications - Call Back | ABC Find My Shares Portal');

        this.status = [
            { statusName: 'Accepted', value: '1' },
            { statusName: 'New Application', value: '2' },
            { statusName: 'Pending - More Information', value: '3' },
            { statusName: 'Rejected', value: '4' }
        ];
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        this.loading = true;
        this.nodeService.getApplicationsCallback().then(files => this.files1 = files);

        this.filterForm = this.fb.group({
            'applicationStatus': new FormControl(null),
            'dateFrom': new FormControl(null),
            'dateTo': new FormControl(null),
            'searchText': new FormControl(null),
        });

    }

    setStatusClass(status) {
        switch (status) {
            case 'Accepted':
                return 'green';
            case 'New Application':
                return 'grey';
            case 'Pending - More Information':
                return 'blue';
            case 'Rejected':
                return 'red';
        }
    }

}
